module.exports = __webpack_public_path__ + "static/microcopy-taxonomy-51157484ed9bc9a7d700b1ef9c1709f0.png";